import React, {useEffect} from 'react';
import PublicHomePage from "./PublicHomePage";

export default function AboutUsPage(props) {

    return <PublicHomePage aboutUs={true}/>
}